// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__nfBn2","textContainer":"AboutUs_textContainer__k2ynE","title":"AboutUs_title__C5RuO","hr":"AboutUs_hr__t9xzK"};